import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import Comission from 'services/Comission'
import General from 'services/General'
import Document from 'services/Document'
import Logo from 'icons/logo-cutilei-simple.png'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { FaFilePdf } from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  EarningContainer,
  Row,
  LabelRow,
  Image,
  SubTitle,
  MoneyTextMask
} from './styles'

export default function MonthlyCutileiServicesModal ({
  visible,
  schedules,
  dateRange,
  onClose: handleClose
}) {
  const [downloading, setDownloading] = useState (false)

  if (!schedules || schedules.length === 0) return null

  const { business } = schedules[0]
  const startDate = DateTime.fromISO (dateRange[0]).toFormat ('dd/MM/yyyy')
  const endDate = DateTime.fromISO (dateRange[1]).toFormat ('dd/MM/yyyy')

  const sortEarningsByType = earnings => ([
    {
      name: 'TOTAL',
      qtd: earnings.reduce (sumItemsAmount, 0),
      totalEarnings: Comission.getTotalEarnings (earnings, { value: 'cutilei' }),
      professionalEarnings: Comission.getProfessionalEarnings (earnings, { value: 'cutilei' }),
      businessEarnings: Comission.getBusinessEarnings (earnings, { value: 'cutilei' })
    },
    ...General.groupBy (earnings.map (e => ({
      ...e, name: Comission.getItemLabel (e)
    })), 'name').map (earnings => ({
      name: earnings[0].name,
      qtd: earnings.reduce (sumItemsAmount, 0),
      totalEarnings: earnings.filter (billedItems).reduce (sumItemsTotal, 0),
      professionalEarnings: earnings.reduce (sumProfessionalItemsTotal, 0),
      businessEarnings: earnings.filter (billedItems).reduce (sumBusinessItemsTotal, 0)
    })).sort ((a, b) => b.qtd - a.qtd)
  ])

  const billedItems = item => Comission.isBilledItem (item)
  const sumItemsAmount = (total, earning) => total + (earning.amount || 1)
  const sumItemsTotal = (total, item) => total + Comission.getItemTotalEarnings (item)
  const sumBusinessItemsTotal = (total, item) => total + Comission.getItemBusinessEarnings (item)
  const sumProfessionalItemsTotal = (total, item) => (
    total + Comission.getItemProfessionalEarnings (item)
  )

  const handleExportPDF = () => {
    Document.downloadBusinessEarningsPDF ({
      business, dateRange, sortedEarnings, setDownloading
    })
  }

  const sortedEarnings = sortEarningsByType (schedules)

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='xl' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Agendamentos - {business.name} ({startDate} a {endDate})</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <SecondaryButton
              label='Exportar PDF'
              leftIcon={<FaFilePdf size={14} color='#FFC100'/>}
              onClick={handleExportPDF}
              disabled={downloading}
              loading={downloading}
              width={160}
              style={{marginBottom: 15}}
            />
            <LabelRow>
              <SubTitle>Serviço</SubTitle>
              <SubTitle>Qtd.</SubTitle>
              <SubTitle>Total bruto</SubTitle>
              <SubTitle>Comissões</SubTitle>
              <SubTitle>Total líquido</SubTitle>
            </LabelRow>
            {sortedEarnings.map ((earning, index) => (
              <EarningContainer key={index}>
                <Row>
                  <Image src={Logo} alt='Service Cutilei'/>
                  <SubTitle>{earning.name}</SubTitle>
                </Row>
                <SubTitle>{earning.qtd}</SubTitle>
                <MoneyTextMask value={earning.totalEarnings}/>
                <MoneyTextMask value={earning.professionalEarnings}/>
                <MoneyTextMask value={earning.businessEarnings}/>
              </EarningContainer>
            ))}
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
